import { sendWSPush } from '@/utils/websocket';
/**
 * 前端操作三维模型的方法集合
 */
export {
  i3dInit,
  i3dChangeViewByCode,
  i3dChangeCamera,
  i3dHighLight,
  i3dSinkOpen,
  i3dSinkOff,
  i3dPreviewLineCheck,
  i3dStartLineCheck,
  i3dStopLineCheck,
  i3dAnimate,
  i3dWeather,
  i3dDeviceRun,
  i3dDeviceStop,
  i3dDayAndNight,
  i3dCheckView,
  i3dCutView,
  i3dActionPreviewOn,
  i3dActionPreviewOff,
};
function i3dBridge(config) {
  const finalConfig = {
    command: [config],
  };
  if (window.location.href.includes('192.168.1.1')) {
    console.log('本地环境不发通知 :>> ');
  } else {
    sendWSPush({
      topic: 'front',
      content: JSON.stringify(finalConfig),
    });
  }
}

/**
 * 回到初始化
 */
function i3dInit() {
  const config = {
    code: '000',
    type: 'init',
  };
  i3dBridge(config);
}

/**
 *  视角切换
 * @param {*} viewpoint_code 固定坐标编号 传'dz'表示主视角
 */
function i3dChangeViewByCode(viewpoint_code) {
  const config = {
    code: '001',
    viewpoint_code: viewpoint_code || 'JK001',
  };
  i3dBridge(config);
}

/**
 * 控制摄像头，
 * @param {*} model_code 摄像头编号如'JK002'，多个传'JK002,JK003',全部传'all'
 * @param {*} type S1：机电设备、S2：视频监控、S3：安全监测、S4：水情预警、S5：水质预警、S6：设备运行
 * @param {*} state 0 隐藏，1 显示
 */
function i3dChangeCamera(model_code, type, state) {
  const config = {
    code: '002',
    model_code: model_code || 'JK002',
    type: type || 'S2',
    state: state || 0,
  };
  i3dBridge(config);
}

/**
 * 控制模型高亮
 * @param {*} model_code 设备编号 单个:['SLJ001'],多个:['SLJ001,SLJ002'],全部:多次调用该方法,
 * 关闭高亮或者关闭下沉：0
 * @param {*} type
 * T1：电站总览(机电设备)，
 * T2：故障诊断，仅支持 传一个 model_code
 * T3：巡检路线，model_code传路线编号 目前仅有'07' 规则同上
 * T4：模型下沉，
 * T5：电站运维
 * T6: 预警高亮 支持传多个model_code:'SLJ001,SLJ002'
 * @param {*} color
 * 故障高亮颜色指令
 * -1：故障
    1：正常
    2：已排查
    3：预警
    @param {*} state
    0:取消所有状态高亮
    1:正常高亮，会清除标牌
    2:正常高亮的时候不清除标牌
    3:清除高亮和标牌，外壳依旧保持隐藏状态
 */
function i3dHighLight(model_code, type, state, color) {
  const config = {
    code: '003',
    model_code: model_code || ['SLJ001'],
    color: color || '1',
    type: type || 'T1',
    state: state || 1,
  };
  i3dBridge(config);
}

// 开启下沉
function i3dSinkOpen() {
  const config = {
    code: '003',
    model_code: [],
    color: '',
    type: 'T4',
    state: 1,
  };
  i3dBridge(config);
}
function i3dSinkOff() {
  const config = {
    code: '003',
    model_code: [],
    color: '',
    type: 'T4',
    state: 0,
  };
  i3dBridge(config);
}

/**
 * 预览巡检路线
 * @param {*} lineId
 * @param {*} patrol_type 0或1 0 数据巡检，1 实时巡检 目前只有0
 */
function i3dPreviewLineCheck(lineId) {
  const config = {
    code: '004',
    lineId: lineId || `07`,
    patrol_type: 0,
    state: 'load',
    time: '',
    pos: '',
  };
  i3dBridge(config);
}

/**
 * 开始巡检
 * @param {*} lineId 路线编号
 * @param {*} patrol_type 0或1 0 数据巡检，1 实时巡检 目前只有0
 */
function i3dStartLineCheck(lineId) {
  const config = {
    code: '004',
    lineId: lineId || `07`,
    patrol_type: 0,
    state: 'begin',
    time: '',
    pos: '',
  };
  i3dBridge(config);
}

/**
 * 停止巡检 不用传参
 * @param {*} lineId 路线编号
 * @param {*} patrol_type 0或1 0 数据巡检，1 实时巡检 目前只有0
 */
function i3dStopLineCheck() {
  const config = {
    code: '004',
    lineId: '0',
    patrol_type: 0,
    state: 'load',
    time: '',
    pos: '',
  };
  i3dBridge(config);
}

/**
 * 
 * @param {*} type 
 * 01：水轮机转动
    02：水轮机运转
    03：拆解动画
    04：组装动画
 * @param {*} state 
    play 播放
    pause 暂停
    continue 继续
    stop 停止退出
 */
function i3dAnimate(type, state) {
  const config = {
    code: '005',
    type: type || '02',
    state: state || 'play',
  };
  i3dBridge(config);
}

/**
 *
 * @param {*} type
 * rain 雨
 * snow 雪
 * sun 晴
 * 若要停止 请默认传sun
 * @param {*} state
 * small 小
 * center 中
 * big 大
 */
function i3dWeather(type, state) {
  const config = {
    code: '006',
    type: type || 'sun',
    state: state || '',
  };
  i3dBridge(config);
}

/**
 * 设备运行
 */
function i3dDeviceRun() {
  const config = {
    code: '007',
    type: '',
    state: 'play',
  };
  i3dBridge(config);
}

/**
 * 设备停止
 */
function i3dDeviceStop() {
  const config = {
    code: '007',
    type: '',
    state: 'stop',
  };
  i3dBridge(config);
}

/**
 * 昼夜控制
 * state:auto昼夜自动切换，move手动滑动条控制
 */
function i3dDayAndNight(state) {
  const config = {
    code: '008',
    type: '',
    state: state || 'auto',
  };
  i3dBridge(config);
}

/**
 * 巡检点位视角
 * @param {*} 非必填 type：点位code
 * 大坝：06
 * 机房看水轮机，07
 * 电站室外：08
 */
function i3dCheckView(type) {
  const config = {
    code: '009',
    type: type || '01',
  };
  i3dBridge(config);
}

/**
 * 剖切视角 水轮机剖切视角 打开/关闭 open/close
 * @param {*} state
 */
function i3dCutView(state) {
  const config = {
    code: '010',
    state: state || 'open',
  };
  i3dBridge(config);
}

/**
 * 大坝预演
 * rain:-1雨停,1小雨,2中雨,3大雨
 * water:1低水位/2中水位/3高水位
 * overflow:-1不溢流/1溢流
 * fadian:-1不发电/1发电
 * 例:
 * actionArr:[rain,water,overflow,fadian]
 */
function i3dActionPreviewOn(actionArr) {
  const config = {
    code: '011',
    actionPreview: actionArr || [-1, 1, -1, -1],
  };
  i3dBridge(config);
}
function i3dActionPreviewOff() {
  const config = {
    code: '011',
    actionPreview: [-1, 1, -1, -1],
  };
  i3dBridge(config);
}
